export const Address = ({ city, street, streetNumber, postCode, showIcon = false }: { city: string, street: string, streetNumber: string, postCode: string, showIcon?: boolean }) => `${street} ${streetNumber}, ${city} ${postCode}`
